import { PlusOutlined } from '@ant-design/icons';
import {
  deleteSubjectMatter,
  subjectMatterCheck,
  subjectMatterMark,
  subjectMatterRecall
} from '@api/announcement';
import { NoticeItemInterface } from '@api/announcement/type';
import { createProject, updateProject } from '@api/project';
import { DeletePrompt } from '@components/Popup/Prompt/deletePrompt';
import { PROJECT_MODE } from '@components/ProjectFromComponents/data';
import ZeissButton from '@components/button';
import RevertModal from '@components/revertModal';
import ZeissTable from '@components/table';
import { userInfo } from '@store';
import type { TableProps } from 'antd';
import { Form, Space, message } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useImmer } from 'use-immer';
import { CreateProject } from '../../../../../../components/ProjectFromComponents/CreateProject';
import { AnnFooterPopup } from '../../Footer/Popup/annFooterPopup';
import { CreateSubjectMatterPopup } from './CreateSubjectMatterPopup';
import { RemarkPopup } from './RemarkPopup';
import { RepeatMatterPopup } from './RepeatMatterPopup';
import { SubjectMatterCheckPopup } from './SubjectMatterCheckPopup';
import { use_ALL_SubMatter_COLUMNS, SubjectMatterStatus } from './columns';
import './index.scss';

interface RecordData {
  username?: string;
  email?: string;
  phone?: string;
  userId?: string;
  subjectMatterCode?: string;
  checkNeedOperation: () => any;
}

export const useSubjectMatter = ({
  details,
  getAnnInfo,
  dict,
  systemCity,
  confirmHandleAnn,
  isFinishAction,
  isReturnAction,
  checkNeedOperation
}: any) => {
  const [data, setData] = useImmer([]);
  const [delId, setDelId] = useState('');
  const [open, setOpen] = useState(false); //修改 & 新增
  const [recordData, setRecordData] = useState({});
  const [delOpen, setdelOpen] = useState(false); //删除
  const [createProjectOpen, setCreateProjectOpen] = useState(false); //创建项目
  const [form] = Form.useForm();
  const [revertModalShow, setRevertModalShow] = useState<boolean>(false);
  const [unrelatedOpen, setUnrelatedOpen] = useState(false); //不相关
  const [repeatOpen, setRepeatOpen] = useState(false); //重复
  const [remarkOpen, setRemarkOpen] = useState(false); //备注
  const [subjectMatterCheckOpen, setSubjectMatterCheckOpen] = useState(false); //标的物操作
  const [curTableItem, setCurTableItem] = useState<any>({});
  const [selectedRecord, setSelectedRecord] = useImmer<any>({});
  const [userInfos] = useRecoilState(userInfo);
  const { roleKeys } = userInfos;

  // const { isFirst } = details;

  //显示删除框
  const handleClickDel = async (id: string) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setdelOpen(true);
    setDelId(id);
  };

  //修改标的物
  const handleEditSubMatter = async (record: RecordData) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setOpen(true);
    setRecordData(record);
  };

  //不相关
  const handleClickUnrelate = async (record = {}) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setUnrelatedOpen(!unrelatedOpen);
    setSelectedRecord(record);
  };

  //重复
  const handleClickRepeat = async (record = {}) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setRepeatOpen(!repeatOpen);
    setSelectedRecord(record);
  };

  //备注
  const handleClickRemark = async (record = {}) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setRemarkOpen(!remarkOpen);
    setSelectedRecord(record);
  };

  //标的物操作
  const handleClickCheck = () => {
    setSubjectMatterCheckOpen(!subjectMatterCheckOpen);
  };

  const handleCheckOk = () => {
    setSubjectMatterCheckOpen(!subjectMatterCheckOpen);
    confirmHandleAnn();
  };

  //创建项目
  const handleCreateProject = async (record: RecordData) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setCreateProjectOpen(!createProjectOpen);
    setSelectedRecord(record);
  };

  const onRevertConfirm = async () => {
    const params = {
      code: curTableItem.subjectMatterCode,
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await subjectMatterRecall(params);
    getAnnInfo();
    setRevertModalShow(false);
  };

  const handleRevert = async (data: any) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setRevertModalShow(true);
    setCurTableItem(data);
  };

  const actionObj: TableProps<RecordData>['columns'] = useMemo(() => {
    if (roleKeys === 'sales' || roleKeys === 'dealer') {
      return [
        {
          title: '操作',
          key: 'action',
          width: 220,
          fixed: 'right',
          align: 'left',
          render: (record: any) => {
            return (
              <Space size={'middle'}>
                <>
                  {!record.subjectMatterStatus ? (
                    <>
                      <a onClick={() => handleCreateProject(record)}>
                        创建项目
                      </a>
                      <div
                        className="pc-roleAdmin-del"
                        onClick={() => handleClickUnrelate(record)}
                      >
                        不相关
                      </div>
                      <div
                        className="pc-roleAdmin-repeat"
                        onClick={() => handleClickRepeat(record)}
                      >
                        关联项目
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="pc-sub-operationText">
                        {SubjectMatterStatus[record.subjectMatterStatus]}
                      </div>
                      {record.subjectMatterStatus !== 1 ? (
                        <a onClick={() => handleClickRemark(record)}>
                          查看备注
                        </a>
                      ) : null}
                      {record.subjectMatterStatus === 2 ||
                      record.subjectMatterStatus === 3 ? (
                        <div
                          className="pc-roleAdmin-del"
                          onClick={() => handleRevert(record)}
                        >
                          撤回
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                </>
              </Space>
            );
          }
        }
      ];
    } else {
      // if (isFirst) {
      return [
        {
          title: '操作',
          key: 'action',
          width: 180,
          fixed: 'right',
          align: 'left',
          render: (record: any) => {
            return record?.subjectMatterStatus === 0 ? (
              <Space size={'middle'}>
                <>
                  <a onClick={() => handleEditSubMatter(record)}>修改</a>
                  <div
                    className="pc-roleAdmin-del"
                    onClick={() =>
                      handleClickDel(record?.subjectMatterCode || '')
                    }
                  >
                    删除
                  </div>
                </>
              </Space>
            ) : (
              <Space size={'middle'}>
                <>
                  <div className="pc-sub-operationText">
                    {SubjectMatterStatus[record.subjectMatterStatus]}
                  </div>
                  {record.subjectMatterStatus !== 1 ? (
                    <a onClick={() => handleClickRemark(record)}>查看备注</a>
                  ) : null}
                </>
              </Space>
            );
          }
        }
      ];
      // }
      // else {
      //   return [
      //     {
      //       title: '操作',
      //       key: 'action',
      //       width: 180,
      //       fixed: 'right',
      //       align: 'left',
      //       render: (record: any) => {
      //         return (
      //           <Space size={'middle'}>
      //             <>
      //               <div className="pc-sub-operationText">
      //                 {SubjectMatterStatus[record.subjectMatterStatus]}
      //               </div>
      //               {record.subjectMatterStatus !== 1 ? (
      //                 <a onClick={() => handleClickRemark(record)}>查看备注</a>
      //               ) : null}
      //             </>
      //           </Space>
      //         );
      //       }
      //     }
      //   ];
      // }
    }
  }, [details]);

  // const actionObj: TableProps<RecordData>['columns'] =
  //   isFirst && !isFinishAction
  //     ? [
  //       {
  //         title: '操作',
  //         key: 'action',
  //         width: 180,
  //         fixed: 'right',
  //         align: 'left',
  //         render: (record: any) => {
  //           return (
  //             <Space size={'middle'}>
  //               {roleKeys === 'sales' ? (
  //                 <>
  //                   {!record.subjectMatterStatus ? (
  //                     <>
  //                       <a onClick={() => handleCreateProject(record)}>
  //                         创建项目
  //                       </a>
  //                       <div
  //                         className="pc-roleAdmin-del"
  //                         onClick={() => handleClickUnrelate(record)}
  //                       >
  //                         不相关
  //                       </div>
  //                       <div
  //                         className="pc-roleAdmin-repeat"
  //                         onClick={() => handleClickRepeat(record)}
  //                       >
  //                         重复
  //                       </div>
  //                     </>
  //                   ) : (
  //                     <>
  //                       <div className="pc-sub-operationText">
  //                         {SubjectMatterStatus[record.subjectMatterStatus]}
  //                       </div>
  //                       {record.subjectMatterStatus !== 1 ? (
  //                         <a onClick={() => handleClickRemark(record)}>
  //                           查看备注
  //                         </a>
  //                       ) : null}
  //                     </>
  //                   )}
  //                 </>
  //               ) : (
  //                 <>
  //                   <a onClick={() => handleEditSubMatter(record)}>修改</a>
  //                   <div
  //                     className="pc-roleAdmin-del"
  //                     onClick={() =>
  //                       handleClickDel(record?.subjectMatterCode || '')
  //                     }
  //                   >
  //                     删除
  //                   </div>
  //                 </>
  //               )}
  //             </Space>
  //           );
  //         }
  //       }
  //     ]
  //     : [];

  const isUncorrelatedOrRepeat = useMemo(() => {
    return (
      details.noticeStatus?.toString() === '5' ||
      details.noticeStatus?.toString() === '6'
    );
  }, [details]);

  const columns: TableProps<RecordData>['columns'] = [
    ...use_ALL_SubMatter_COLUMNS(details),
    ...(isUncorrelatedOrRepeat ? [] : [...actionObj])
  ];

  const deleteAccount = async () => {
    await deleteSubjectMatter([`${delId}`]);
    setOpen(false);
    message.success('删除成功!');
    getAnnInfo();
  };

  //新增标的物
  const handleClickAddSub = async () => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setOpen(true);
    setRecordData({});
  };

  //标的物是否都操作check
  const subjectMatterCheckFn = async () => {
    await getAnnInfo();
    if (!selectedRecord?.noticeCode) {
      return;
    }
    const res = await subjectMatterCheck({
      noticeCode: selectedRecord.noticeCode
    });
    if (res) {
      handleClickCheck();
    }
  };

  //不相关操作按钮确认回调
  const unrelatedConfirmCallback = async (val: any) => {
    const unrelatedReasonItem = val.unrelatedReason?.split('-');
    const reason = unrelatedReasonItem.slice(1).join('-');
    const options = {
      noticeCode: selectedRecord.noticeCode,
      subjectMatterCodes:
        selectedRecord.subjectMatterCode &&
        selectedRecord.subjectMatterCode.split(','),
      action: 5,
      subjectMatterStatus: 2,
      subjectMatterStatusValue: '不相关',
      subjectMatterRemark: val.recordRemark,
      unrelatedReason: unrelatedReasonItem[0],
      unrelatedReasonValue: reason
    };
    if (reason) {
      options.subjectMatterRemark = options.subjectMatterRemark
        ? `${reason}：${options.subjectMatterRemark}`
        : `${reason}`;
    }
    await subjectMatterMark(options);
    message.success('已标记不相关');
    await subjectMatterCheckFn();
  };

  useEffect(() => {
    if (details.subjectMatter) {
      setData(details.subjectMatter);
    }
  }, [details]);

  const handleOk = async (data: NoticeItemInterface) => {
    const { infoId } = details;
    data?.subjectMatterProjectCode
      ? await updateProject({
          ...data,
          subjectMatterProject: true,
          infoId,
          noticeCode: details?.noticeCode
        })
      : await createProject({
          ...data,
          subjectMatterProject: true,
          infoId,
          noticeCode: details?.noticeCode
        });
    setCreateProjectOpen(false);
    form.resetFields();
    await subjectMatterCheckFn();
  };

  const renderToolBar = () => {
    if (isFinishAction || isReturnAction) {
      return '';
    }
    return (
      <ZeissButton
        className="pc-sub-addBtn"
        icon={<PlusOutlined />}
        onClick={handleClickAddSub}
      >
        新增
      </ZeissButton>
    );
  };

  const subMatterComponent = (
    <div className="pc-sub-container">
      <div className="pc-sub-tit">
        <div>标的物</div>
        <div>{renderToolBar()}</div>
      </div>
      <ZeissTable
        rowKey="subjectMatterCode"
        columns={columns}
        dataSource={data}
        bordered={false}
        scroll={{ x: 1800 }}
        pagination={false}
        autoScrollY={false}
      />
      <CreateSubjectMatterPopup
        record={recordData}
        getAnnInfo={getAnnInfo}
        details={details}
        open={open}
        setOpen={setOpen}
        dict={dict}
      />
      <DeletePrompt
        popupTitle="确认删除该标的物？"
        open={delOpen}
        setOpen={setdelOpen}
        confirmCallback={deleteAccount}
      />
      {unrelatedOpen && (
        <AnnFooterPopup
          getAnnInfo={getAnnInfo}
          details={details}
          noticeCode={details?.noticeCode || ''}
          actionId={5}
          unrelatedTip={true}
          open={unrelatedOpen}
          confirmCallback={unrelatedConfirmCallback}
          setOpen={setUnrelatedOpen}
          subjectMatterCheckFn={subjectMatterCheckFn}
          isAnnouncement={false}
        />
      )}
      {/* <RepeatMatterPopup open={repeatOpen} handleCancel={handleClickRepeat} /> */}
      <CreateProject
        mode={PROJECT_MODE.CREATE}
        formRef={form}
        noticeRecord={details}
        record={selectedRecord}
        handleOk={handleOk}
        open={createProjectOpen}
        setOpen={setCreateProjectOpen}
        dicList={dict}
        systemCity={systemCity}
      />

      <RepeatMatterPopup
        open={repeatOpen}
        getAnnInfo={subjectMatterCheckFn}
        details={{
          ...selectedRecord,
          dataFlag: details.dataFlag
        }}
        handleCancel={() => setRepeatOpen(false)}
      />
      <RemarkPopup
        open={remarkOpen}
        details={selectedRecord}
        handleCancel={handleClickRemark}
      />
      <SubjectMatterCheckPopup
        open={subjectMatterCheckOpen}
        handleCancel={handleClickCheck}
        handleOk={handleCheckOk}
      />
      <RevertModal
        title="请确认是否撤回该标的物?"
        open={revertModalShow}
        onCancel={() => setRevertModalShow(false)}
        onConfirm={onRevertConfirm}
      />
    </div>
  );

  return {
    subMatterComponent
  };
};
